// Comprueba si un campo tiene un mínimo de caracteres y si es numérico
export const checkValid = (field, minChars, numeric = false) => {
  if (!field || field.length < minChars || (numeric && Number.isNaN(field))) {
    return false;
  }
  return true;
};

// Comprueba que todos los campos sean correctos
export const isFormValid = parent => {
  const checkIsValid = value => value;
  let valid = true;

  if (!Object.values(parent).every(checkIsValid)) {
    valid = false;
  }
  return valid;
};

// Convierte un booleano en un string
export const getTxtFromBool = bool => (bool ? 'S' : 'N');

// Convierte un string en un booleano
export const getBoolFromTxt = txt => txt === 'S';

// Convierte la letra recibida en el servicio en el texto correspondiente para el dropdown de género
export const getGenderLabelFromLetter = letter => {
  switch (letter) {
    case 'H':
      return 'Hombre';
    case 'M':
      return 'Mujer';
    default:
      return 'Seleccionar';
  }
};
